var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-admin-estates-item-info-legal"},[_c('ui-form',{attrs:{"model":_vm.fields,"validation":_vm.validation,"submit-handler":_vm.submitHandler,"gap":"wide"},on:{"update":_vm.updateFormData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }